import React, { useEffect, useState } from "react";

// hooks
import { useRedux } from "../../../hooks/index";
import { createSelector } from "reselect";
// actions
import {
  toggleUserDetailsTab,
  getChatUserConversations2,
  onSendMessage,
  receiveMessage,
  readMessage,
  receiveMessageFromUser,
  deleteMessage,
  deleteUserMessages,
  toggleArchiveContact,
  setProfileActiveTab,
} from "../../../redux/actions";

// hooks
import { useProfile } from "../../../hooks";

// components
import UserHead from "./UserHead";
import Conversation from "./Conversation";
import ChatInputSection from "./ChatInputSection/index";

// interface
import { MessagesTypes } from "../../../data/messages";

// dummy data
import { pinnedTabs } from "../../../data/index";
import NotificationTop from "./NotificationTop";
import ViewMsgMemberModal from "components/ViewMsgMemberModal";
import AudioCallModal2 from "components/ViewMessageReadStatusModal";
import { Utils } from "helpers/utils";
import { USER_DETAILS_TABS } from "../../../redux/chats/types";

interface IndexProps {
  isChannel: boolean;
}
const Index = ({ isChannel }: IndexProps) => {
  // global store
  const { dispatch, useAppSelector } = useRedux();

  const errorData = createSelector(
    (state: any) => state.Chats,
    (state: any) => state.ChatContacts2,
    (state, contact) => ({
      chatUserDetails: state.chatUserDetails,
      chatUserConversations: state.chatUserConversations,
      isUserMessageSent: state.isUserMessageSent,
      isMessageDeleted: state.isMessageDeleted,
      isMessageForwarded: state.isMessageForwarded,
      isUserMessagesDeleted: state.isUserMessagesDeleted,
      isImageDeleted: state.isImageDeleted,
      activeChatRoomList: contact.chatContacts.find((ee: any) => ee.userId == state.selectedChat),
      selectedChat: state.selectedChat,
    })
  );
  // Inside your component
  const { chatUserDetails, chatUserConversations, isUserMessageSent, isMessageDeleted, isMessageForwarded, isUserMessagesDeleted,
    isImageDeleted, activeChatRoomList, selectedChat } = useAppSelector(errorData);

  // console.log('activeChatRoom:', activeChatRoom);

  const onOpenUserDetails = () => {
    dispatch(toggleUserDetailsTab(true));
  };

  const onClickSearchIcon = () => {
    try {
      dispatch(toggleUserDetailsTab(true));
      // setIsOpenUserDetailsTab2(tab);
      dispatch(setProfileActiveTab(USER_DETAILS_TABS.SEARCH));
    } catch (e) {
      console.error(e);
      alert((e as any).message);
    }
  }

  /*
  hooks
  */
  const { userProfile } = useProfile();

  /*
  reply handeling
  */
  const [replyData, setReplyData] = useState<
    null | MessagesTypes | undefined
  >();
  const onSetReplyData = (reply: null | MessagesTypes | undefined) => {
    // console.log('onSetReplyData:', reply);
    setReplyData(reply);
  };

  // 20250611 Reset reply, image, file
  useEffect(()=>{
    onSetReplyData(null);
  }, [selectedChat]);

  /*
  send message
  */
  const onSend = (data: any) => {
    // console.log('onSend xxx :', data);
    let params: any = {
      text: data.text && data.text,
      time: new Date().toISOString(),
      image: data.image && data.image,
      newimage: data.newimage && data.newimage,
      attachments: data.attachments && data.attachments,
      meta: {
        receiver: chatUserDetails.id,
        sender: userProfile.uid,
      },
    };

    if (replyData && replyData !== null) {
      params["replyOf"] = replyData;
    }

    //dispatch(onSendMessage(params));
    if (!isChannel) {
      // setTimeout(() => {
      //   dispatch(receiveMessage(chatUserDetails.id));
      // }, 1000);
      // setTimeout(() => {
      //   dispatch(readMessage(chatUserDetails.id));
      // }, 1500);
      // setTimeout(() => {
      //   dispatch(receiveMessageFromUser(chatUserDetails.id));
      // }, 2000);
    }
    setReplyData(null);
  };


  useEffect(() => {
    if (
      isUserMessageSent ||
      isMessageDeleted ||
      isMessageForwarded ||
      isUserMessagesDeleted ||
      isImageDeleted
    ) {
      dispatch(getChatUserConversations2(chatUserDetails.id, null, null, null, null, null, "Conversation use effect"));
    }
  }, [
    dispatch,
    isUserMessageSent,
    chatUserDetails,
    isMessageDeleted,
    isMessageForwarded,
    isUserMessagesDeleted,
    isImageDeleted,
  ]);

  const onDeleteMessage = (messageId: string | number) => {
    dispatch(deleteMessage(chatUserDetails.id, messageId));
  };

  const onDeleteUserMessages = () => {
    dispatch(deleteUserMessages(chatUserDetails.id));
  };

  const onToggleArchive = () => {
    dispatch(toggleArchiveContact(chatUserDetails.id));
  };

  const [isOpenAudioModal, setIsOpenAudioModal] = useState<boolean>(false);
  const onOpenAudio = () => {
    // console.log('UserProfilesDetails.onOpenAudioClick');
    setIsOpenAudioModal(true);
  };
  const onCloseAudio = () => {
    setIsOpenAudioModal(false);
  };

  return (
    <>
      {/* <NotificationTop title="NewMessage" message="Hello" imageUrl="https://png.pngtree.com/element_our/20190522/ourmid/pngtree-hand-drawn-woman-face-image_1072035.jpg" onClose={()=>alert('close')}></NotificationTop> */}

      <UserHead
        chatUserDetails={chatUserDetails}
        activeChatRoom={activeChatRoomList}
        pinnedTabs={pinnedTabs}
        onOpenUserDetails={onOpenUserDetails}
        onDelete={onDeleteUserMessages}
        isChannel={isChannel}
        onToggleArchive={onToggleArchive}
        onClickSearchIcon={onClickSearchIcon}
      />

      <Conversation
        chatUserConversations={chatUserConversations}
        chatUserDetails={chatUserDetails}
        onDelete={onDeleteMessage}
        onSetReplyData={onSetReplyData}
        isChannel={isChannel}
      />


      {Utils.IsViewAs() ? (<div className="alert alert-danger text-center">อยู่ในโหมดมุมมองคนอื่น</div>) : (
        <ChatInputSection
          onSend={onSend}
          replyData={replyData}
          onSetReplyData={onSetReplyData}
          chatUserDetails={chatUserDetails}
        />
      )}

      {/* <button onClick={onOpenAudio}>audio</button> */}

      {/* {isOpenAudioModal && (
        <AudioCallModal2ho
          isOpen={isOpenAudioModal}
          onClose={onCloseAudio}
          user={chatUserDetails}
        />
      )} */}
      {/* {isOpenAudioModal && (
      <ViewMsgMemberModal isOpen={isOpenAudioModal}/>
      )} */}
    </>
  );
};

export default Index;
